export default __webpack_public_path__ + "static/media/daniel.edf92aff.jpg";